export enum Privilege {
  CatalogAdmin = "catalog-admin",
  DerivedAttributeConfigurationRead = "read:derived-attribute-configuration",
  DerivedAttributeConfigurationWrite = "write:derived-attribute-configuration",
  QualityIssueConfigurationRead = "read:quality-issue-configuration",
  QualityIssueConfigurationWrite = "write:quality-issue-configuration",
  RestrictionConfigurationRead = "read:restriction-configuration",
  RestrictionConfigurationWrite = "write:restriction-configuration",
}
